var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toApp_box"},[_c('img',{staticClass:"toApp_img",attrs:{"src":require("../../../assets/img/toapp.png"),"alt":""}}),_vm._v(" "),_c('a',{staticClass:"toApp_btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('clickClose')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87d01840","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cdjs/children/toApp.vue
// module id = null
// module chunks = 